<app-qa-check-list scrollHeight="540px" [fields]="fields" [form]="qualityAssuranceForm"></app-qa-check-list>
